/** Ported from Clarity `apps/web/src/shared/config/limits.ts` (commit `9015ce88c`). */
/**
 * The size ceiling a Clarity image is measured against (brain's `FILE_SIZE_LIMITS.IMAGE_MAX_MB` and
 * `FILE_SIZE_LIMITS_BYTES.IMAGE_MAX`).
 *
 * **A client courtesy, not a control.** The server enforces its own limit; this one decides what a surface refuses
 * before it uploads — the Domain files panel refuses an image over it with a notice, while the chat shrinks one
 * instead. Every consumer reads these members; nothing restates the numbers.
 */
export const CLARITY_IMAGE_LIMITS = {
	MAX_MB: 10,
	MAX_BYTES: 10 * 1024 * 1024,
} as const;
